import { getCookie, isMobileView } from "../../SEOContainer/Common/utils";


  function getAccountInfo(eventDetails){
    let loginStatus = getCookie('OAUTH-GOIBIBO')  ? "Logged-In" : "Guest";
    return {
        accountInfo: {
          custID:'',
          loginStatus:  loginStatus,
          goCash: '',
          loyaltyStatus: "",
          hydraSegment: "",
        },
      }
  }

 function getBusInfo({pageName}){
    return {
        section: "domestic bus funnel",
        pageName: `${pageName}`,
        pageType: "seo",
        lob: "domestic bus",
        platform: isMobileView()?'mWeb':'dWeb', // TODO
        siteName: 'GI',
        flow: `${"direct-bus"}`,
        loadedComponents: '',
        abVariant: 'Is_IsoSEO_F' ,
        deviceId: "",
        devLang : 'NonIsomorphic_SEO'
      }
 }
 
 
 export const ctaHelper = (ctaValues) => {
  return {
    name: ctaValues[0],
    type: ctaValues[1],
    componentName: ctaValues[2],
    destination: ctaValues[3]
  }
}

export const trackFilterEvent = ({ selectedFilterType, selectedFilters = {}, type }) => {
  const fillterList = Object.keys(selectedFilters).map((key) => {
    return `[${key}]:[${JSON.stringify(selectedFilters[key])}]`
  }).join("|");

  const event = {
    "filter": {
      [type === "select" ? "filterSelected" : "filterRemoved"]: selectedFilterType,
      "appliedFiltersList": fillterList
    }
  }
  const eventName = type === "select" ? "filterSelection" : "filterRemoval";
  trackActionEvent(eventName, event);
}

export const calculateDaysToTrip = (dateVal) => {
  if(!dateVal){
    return ''
  }
  const curDate = new Date();
  const dateDiff : number = Math.abs(dateVal.getTime() - curDate.getTime())
  return Math.round(dateDiff/(1000*60*60*24)).toString(); 
}


export const convert_yyyymmdd_to_dd_mm_dddd = (dateVal) => {
  try {
      const year = dateVal.slice(0, 4);
      const month = dateVal.slice(4, 6);
      const day = dateVal.slice(6,);
      const ans = `${day}-${month}-${year}`;
      return ans;
  } catch (e) {
      return "";
  }
};

export const calculateDroppingDate = (dateString, depTime, arrTime) => {
  let mydate;
  if(arrTime < depTime){
    mydate = new Date(dateString.split('-').reverse().join('-'));
    mydate.setDate(mydate.getDate() + 1);
    let mm = mydate.getMonth() + 1; // getMonth() is zero-based
    let dd = mydate.getDate();

    return [(dd>9 ? '' : '0') + dd,
            (mm>9 ? '' : '0') + mm,
            mydate.getFullYear(),
          ].join('-');
  }
  return dateString;
}
export enum CTA_TYPE {
  BUTTON = "Button",
  HYPER_LINK = "Hyperlink",
  RADIO_BUTTON = "Radio Button",
  IMAGES = "Images"
}

export const availableOffers = (promos) => {
  let offersString = "[";
  if(promos.length === 0) return offersString+']';
  promos?.map((promo) => {
    offersString = offersString + promo?.key + ':' + promo?.value + "|";
  })
  const offersStringNew = offersString.slice(0, -1) + ']';
  return offersStringNew
}

export const countRtcBuses = (operators) => {
  let count = 0;
  operators && operators.map((bus) => {
      count+=bus.total_count;
  })
  return count;
}

export const seatNumberMethod = (selectedSeats) => {
  let seatNoString = "[";
  let temp = "";
  selectedSeats?.map((seat)=>{
    seatNoString=seatNoString+seat?.seat+"|";
  })
  const seatNoStringNew = seatNoString.slice(0, -1) + ']';
  return seatNoStringNew
}

export const allFiltersApplied = (selectedFilters={}) => {
  let filterString = '[';
  for(const [key, value] of Object.entries(selectedFilters)){
      if(key==='operator'){ 
          if(Object.keys(value).length !== 0){
          for(const [opid, opname] of Object.entries(value)){
              filterString+=(opname+'|')
          }
          continue;
      }
          else{
              continue;
          }
      }
      value && value.map((item) => {
          filterString+=(item+'|')
      })
  }

  if(filterString.length===1){
      return filterString+']'
  }
  else{
      return filterString.slice(0, -1)+']';
  }
}
export const getDate = (date="")=>{
  return new Date([date.substring(0,4),date.substring(4,6),date.substring(6)].join("-"));
}

export function getUpdateSearchPayload({src_name,dest_name,selectedDate}){
  const date = getDate(selectedDate);
  return {
    search: {
      searchId: `${src_name}_${dest_name}_${selectedDate}`,
    },
    cta: ctaHelper(['Update_Search', CTA_TYPE.BUTTON, 'Header', 'SRP']),
    booking: {
      routeCity: `${src_name}_${dest_name}`,
      routeState: '_',
      daysToTrip: calculateDaysToTrip(date),
      departureDate: convert_yyyymmdd_to_dd_mm_dddd(date),
    },
  };
}



const sendOmnitureEvent = (eventName:string,details:any)=>{
  try {
      window.adobeDataLayer = window.adobeDataLayer || []
      window.adobeDataLayer.push({
        event: eventName,
        ...details
      })
    } catch (err) {
      console.log(err)
    }
}

type Event={
    pageName: string;
    details?: any;
    booking?:any;
}

export const sendPageViewEvent = (eventDetails:Event)=>{
    const event = {
        page: { pageInfo: { ...getBusInfo({ pageName: eventDetails.pageName }) } },
        account: {...getAccountInfo(eventDetails.details)},
        ...eventDetails.details
    }
    if(eventDetails?.booking) {event['booking'] = eventDetails?.booking}
    sendOmnitureEvent("pageView",event);
}

export const trackActionEvent = (eventName, eventDetails, options?) => {
  const finalEvent = {
    ...eventDetails,
    ...(options?.global) && { ...getBusInfo({ pageName: eventDetails.pageName }), ...getAccountInfo(eventDetails) }
  }
  sendOmnitureEvent(eventName, finalEvent);
}